import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PANEL_TYPES } from '../../../shell/panel-state'
// Register the subscription panel plus the foreign panels the record page
// cross-references (company / contact / product) so they open in place.
import '../../../modules/companies/register-panels'
import '../../../modules/contacts/register-panels'
import '../../../modules/products/register-panels'
import '../../../modules/subscriptions/register-panels'
import { SubscriptionFullPage } from '../../../modules/subscriptions/subscription-full-page'

const detailSearchSchema = z.object({
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
})

/** The full-page subscription record at /subscriptions/:id. */
export const Route = createFileRoute('/_authed/subscriptions/$subscriptionId')({
  validateSearch: detailSearchSchema,
  component: SubscriptionDetailRoute,
})

function SubscriptionDetailRoute() {
  const { subscriptionId } = Route.useParams()
  return <SubscriptionFullPage subscriptionId={subscriptionId} />
}
